import { useEffect, useState } from "react";
import { config } from "@/config";

export interface PublicStats {
  objects: number;
  signals: { total: number; low: number; medium: number; high: number; critical: number };
  assets: number;
  sources: number;
  rules: number;
  latencyP50Ms: number | null;
}

const FALLBACK: PublicStats = {
  objects: 30000,
  signals: { total: 0, low: 0, medium: 0, high: 0, critical: 0 },
  assets: 25000,
  sources: 5,
  rules: 9,
  latencyP50Ms: null,
};

let globalCache: PublicStats | null = null;

export function usePublicStats(): PublicStats {
  const [stats, setStats] = useState<PublicStats>(globalCache ?? FALLBACK);

  useEffect(() => {
    if (globalCache) return;
    let cancelled = false;
    fetch(`${config.restUrl}/api/public/stats`)
      .then((r) => r.json())
      .then((d: PublicStats) => {
        if (cancelled) return;
        globalCache = d;
        setStats(d);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return stats;
}
